const Hosts = {
  host: "//api.laodas.com/",
  loginHost: "//api.laodas.com/"
};

if (process.env.NODE_ENV === "production") {
  Hosts.host = "//api.laodas.com/";
  Hosts.loginHost = "//api.laodas.com/";
}

export { Hosts };
